export class Color {
  id: number | string = 0
  name: string = ''
  color: string = ''

  constructor(data: Partial<Color> = {}) {
    Object.assign(this, data)
  }

  static colorsFromObject(json: { [key: string]: any }): Color[] {
    console.log("FROM JSON", json);
    const entries = Object.entries(json);

    const colors: Color[] = [];

    for (const [key, val] of entries) {
      colors.push({
        id: key,
        name: val,
        color: key
      })
    }

    console.log({ colors });

    return colors;

  }
}
